module.exports = __webpack_public_path__ + "static/img_2465-fb33fba786fc3ec6f7f55d253b51d153.webp";